Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GenerateId = void 0;
var GenerateId = exports.GenerateId = function GenerateId() {
  var _timestamp = Date.now();
  var _saltMaximum = 100;
  var _salt = Math.floor(Math.random() * Math.floor(_saltMaximum));
  return "".concat(_timestamp, "-").concat(_salt);
};